import * as React from 'react'
import { FormattedMessage, WrappedComponentProps, injectIntl } from 'react-intl'

import classnames from 'classnames'
import { Modal, Elements, TextButton } from '@tfo/common'

import './AbortApprovalModal.scss'
import { Grid } from '@material-ui/core'

const { Heading4, Paragraph } = Elements

const AbortApprovalModal: React.FunctionComponent<Modal.ModalProps & {
	companyName: string
} & WrappedComponentProps> = props => {
	const { onCloseClick, onConfirmClick, onDenyClick, companyName } = props

	return (
		<Modal.Modal
			className={classnames('AbortApprovalModal')}
			onDenyClick={onDenyClick}
			onConfirmClick={onConfirmClick}
			onCloseClick={onCloseClick}>
			<Grid container className="AbortApprovalModal__Inner" direction="column">
				<Grid className={'AboutReportModal__Header'} item>
					<Heading4 className="AbortApprovalModal__Heading4">
						<FormattedMessage id="individual.abortApproval.heading" />
					</Heading4>
				</Grid>
				<Grid className="AboutReportModal__ScrollingContent" item>
					<Paragraph className="AbortApprovalModal__Paragraph">
						<FormattedMessage
							id="individual.abortApproval.body"
							values={{ companyName: companyName }}
						/>
					</Paragraph>
				</Grid>
				<Grid
					item
					container
					className="AbortApprovalModal__TextButton"
					direction="row">
					<Grid item>
						<TextButton
							secondary={true}
							className=" AbortApprovalModal__TextButton--left"
							onClick={() => {
								if (onDenyClick) {
									onDenyClick()
								}
							}}>
							<FormattedMessage id="individual.common.btn.cancel" />
						</TextButton>
					</Grid>
					<Grid item>
						<TextButton
							className=" AbortApprovalModal__TextButton--right"
							onClick={() => {
								if (onConfirmClick) {
									onConfirmClick()
								}
							}}>
							<FormattedMessage id="individual.common.btn.confirm" />
						</TextButton>
					</Grid>
				</Grid>
			</Grid>
		</Modal.Modal>
	)
}

export default injectIntl(AbortApprovalModal)
